/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * SkillScape API
 * API для системы управления компетенциями SkillScape
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetPerformanceReviewRoundsRoundIdFormsAboutMe200Item,
  GetPerformanceReviewRoundsRoundIdSummarizers200Item,
  GetPerformanceReviewRoundsRoundIdSummarizersMine200Item,
  PatchPerformanceReviewFormsIdDraftBody,
  PatchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersBody,
  PatchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBody,
  PerformanceReviewRound,
  PostPerformanceReviewRoundsBody,
  PostPerformanceReviewRoundsRoundIdParticipantsBody,
  PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishBody,
  PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareBody,
  PutPerformanceReviewRoundsRoundIdAssignmentsBody,
  PutPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksBody,
  PutPerformanceReviewRoundsRoundIdSummarizersUserIdBody
} from '../model';

import { customAxios } from '../../mutator/customAxios';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type getPerformanceReviewRoundsResponse200 = {
  data: PerformanceReviewRound[]
  status: 200
}

export type getPerformanceReviewRoundsResponseSuccess = (getPerformanceReviewRoundsResponse200) & {
  headers: Headers;
};
;

export type getPerformanceReviewRoundsResponse = (getPerformanceReviewRoundsResponseSuccess)

export const getGetPerformanceReviewRoundsUrl = () => {




  return `/performance-review/rounds`
}

/**
 * @summary List rounds visible to current user
 */
export const getPerformanceReviewRounds = async ( options?: RequestInit): Promise<getPerformanceReviewRoundsResponse> => {

  return customAxios<getPerformanceReviewRoundsResponse>(getGetPerformanceReviewRoundsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerformanceReviewRoundsQueryKey = () => {
    return [
    `/performance-review/rounds`
    ] as const;
    }


export const getGetPerformanceReviewRoundsQueryOptions = <TData = Awaited<ReturnType<typeof getPerformanceReviewRounds>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRounds>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReviewRoundsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerformanceReviewRounds>>> = ({ signal }) => getPerformanceReviewRounds({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRounds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReviewRoundsQueryResult = NonNullable<Awaited<ReturnType<typeof getPerformanceReviewRounds>>>
export type GetPerformanceReviewRoundsQueryError = unknown


export function useGetPerformanceReviewRounds<TData = Awaited<ReturnType<typeof getPerformanceReviewRounds>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRounds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRounds>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRounds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRounds<TData = Awaited<ReturnType<typeof getPerformanceReviewRounds>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRounds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRounds>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRounds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRounds<TData = Awaited<ReturnType<typeof getPerformanceReviewRounds>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRounds>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List rounds visible to current user
 */

export function useGetPerformanceReviewRounds<TData = Awaited<ReturnType<typeof getPerformanceReviewRounds>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRounds>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPerformanceReviewRoundsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type postPerformanceReviewRoundsResponse201 = {
  data: void
  status: 201
}

export type postPerformanceReviewRoundsResponseSuccess = (postPerformanceReviewRoundsResponse201) & {
  headers: Headers;
};
;

export type postPerformanceReviewRoundsResponse = (postPerformanceReviewRoundsResponseSuccess)

export const getPostPerformanceReviewRoundsUrl = () => {




  return `/performance-review/rounds`
}

/**
 * @summary Create a new round (admin)
 */
export const postPerformanceReviewRounds = async (postPerformanceReviewRoundsBody: PostPerformanceReviewRoundsBody, options?: RequestInit): Promise<postPerformanceReviewRoundsResponse> => {

  return customAxios<postPerformanceReviewRoundsResponse>(getPostPerformanceReviewRoundsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postPerformanceReviewRoundsBody,)
  }
);}




export const getPostPerformanceReviewRoundsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRounds>>, TError,{data: PostPerformanceReviewRoundsBody}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRounds>>, TError,{data: PostPerformanceReviewRoundsBody}, TContext> => {

const mutationKey = ['postPerformanceReviewRounds'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPerformanceReviewRounds>>, {data: PostPerformanceReviewRoundsBody}> = (props) => {
          const {data} = props ?? {};

          return  postPerformanceReviewRounds(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPerformanceReviewRoundsMutationResult = NonNullable<Awaited<ReturnType<typeof postPerformanceReviewRounds>>>
    export type PostPerformanceReviewRoundsMutationBody = PostPerformanceReviewRoundsBody
    export type PostPerformanceReviewRoundsMutationError = unknown

    /**
 * @summary Create a new round (admin)
 */
export const usePostPerformanceReviewRounds = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRounds>>, TError,{data: PostPerformanceReviewRoundsBody}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPerformanceReviewRounds>>,
        TError,
        {data: PostPerformanceReviewRoundsBody},
        TContext
      > => {
      return useMutation(getPostPerformanceReviewRoundsMutationOptions(options), queryClient);
    }
    export type getPerformanceReviewRoundsActiveResponse200 = {
  data: void
  status: 200
}

export type getPerformanceReviewRoundsActiveResponseSuccess = (getPerformanceReviewRoundsActiveResponse200) & {
  headers: Headers;
};
;

export type getPerformanceReviewRoundsActiveResponse = (getPerformanceReviewRoundsActiveResponseSuccess)

export const getGetPerformanceReviewRoundsActiveUrl = () => {




  return `/performance-review/rounds/active`
}

/**
 * @summary Get the active round for the current user (or null)
 */
export const getPerformanceReviewRoundsActive = async ( options?: RequestInit): Promise<getPerformanceReviewRoundsActiveResponse> => {

  return customAxios<getPerformanceReviewRoundsActiveResponse>(getGetPerformanceReviewRoundsActiveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerformanceReviewRoundsActiveQueryKey = () => {
    return [
    `/performance-review/rounds/active`
    ] as const;
    }


export const getGetPerformanceReviewRoundsActiveQueryOptions = <TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsActive>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsActive>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReviewRoundsActiveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerformanceReviewRoundsActive>>> = ({ signal }) => getPerformanceReviewRoundsActive({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsActive>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReviewRoundsActiveQueryResult = NonNullable<Awaited<ReturnType<typeof getPerformanceReviewRoundsActive>>>
export type GetPerformanceReviewRoundsActiveQueryError = unknown


export function useGetPerformanceReviewRoundsActive<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsActive>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsActive>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsActive>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsActive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsActive<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsActive>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsActive>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsActive>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsActive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsActive<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsActive>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsActive>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the active round for the current user (or null)
 */

export function useGetPerformanceReviewRoundsActive<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsActive>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsActive>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPerformanceReviewRoundsActiveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getPerformanceReviewRoundsIdResponse200 = {
  data: void
  status: 200
}

export type getPerformanceReviewRoundsIdResponseSuccess = (getPerformanceReviewRoundsIdResponse200) & {
  headers: Headers;
};
;

export type getPerformanceReviewRoundsIdResponse = (getPerformanceReviewRoundsIdResponseSuccess)

export const getGetPerformanceReviewRoundsIdUrl = (id: string,) => {




  return `/performance-review/rounds/${id}`
}

/**
 * @summary Get round details
 */
export const getPerformanceReviewRoundsId = async (id: string, options?: RequestInit): Promise<getPerformanceReviewRoundsIdResponse> => {

  return customAxios<getPerformanceReviewRoundsIdResponse>(getGetPerformanceReviewRoundsIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerformanceReviewRoundsIdQueryKey = (id: string,) => {
    return [
    `/performance-review/rounds/${id}`
    ] as const;
    }


export const getGetPerformanceReviewRoundsIdQueryOptions = <TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsId>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsId>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReviewRoundsIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerformanceReviewRoundsId>>> = ({ signal }) => getPerformanceReviewRoundsId(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReviewRoundsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPerformanceReviewRoundsId>>>
export type GetPerformanceReviewRoundsIdQueryError = unknown


export function useGetPerformanceReviewRoundsId<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsId>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsId>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsId<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsId>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsId<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsId>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get round details
 */

export function useGetPerformanceReviewRoundsId<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsId>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPerformanceReviewRoundsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type deletePerformanceReviewRoundsIdResponse204 = {
  data: void
  status: 204
}

export type deletePerformanceReviewRoundsIdResponseSuccess = (deletePerformanceReviewRoundsIdResponse204) & {
  headers: Headers;
};
;

export type deletePerformanceReviewRoundsIdResponse = (deletePerformanceReviewRoundsIdResponseSuccess)

export const getDeletePerformanceReviewRoundsIdUrl = (id: string,) => {




  return `/performance-review/rounds/${id}`
}

/**
 * @summary Delete a draft round (admin)
 */
export const deletePerformanceReviewRoundsId = async (id: string, options?: RequestInit): Promise<deletePerformanceReviewRoundsIdResponse> => {

  return customAxios<deletePerformanceReviewRoundsIdResponse>(getDeletePerformanceReviewRoundsIdUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePerformanceReviewRoundsIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerformanceReviewRoundsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePerformanceReviewRoundsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deletePerformanceReviewRoundsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePerformanceReviewRoundsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deletePerformanceReviewRoundsId(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePerformanceReviewRoundsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deletePerformanceReviewRoundsId>>>

    export type DeletePerformanceReviewRoundsIdMutationError = unknown

    /**
 * @summary Delete a draft round (admin)
 */
export const useDeletePerformanceReviewRoundsId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerformanceReviewRoundsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePerformanceReviewRoundsId>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeletePerformanceReviewRoundsIdMutationOptions(options), queryClient);
    }
    export type postPerformanceReviewRoundsIdTransitionsTargetStageResponse200 = {
  data: void
  status: 200
}

export type postPerformanceReviewRoundsIdTransitionsTargetStageResponseSuccess = (postPerformanceReviewRoundsIdTransitionsTargetStageResponse200) & {
  headers: Headers;
};
;

export type postPerformanceReviewRoundsIdTransitionsTargetStageResponse = (postPerformanceReviewRoundsIdTransitionsTargetStageResponseSuccess)

export const getPostPerformanceReviewRoundsIdTransitionsTargetStageUrl = (id: string,
    targetStage: 'collect-essay' | 'collect-feedback' | 'summary' | 'finished' | 'archived',) => {




  return `/performance-review/rounds/${id}/transitions/${targetStage}`
}

/**
 * @summary Transition round to target stage (admin)
 */
export const postPerformanceReviewRoundsIdTransitionsTargetStage = async (id: string,
    targetStage: 'collect-essay' | 'collect-feedback' | 'summary' | 'finished' | 'archived', options?: RequestInit): Promise<postPerformanceReviewRoundsIdTransitionsTargetStageResponse> => {

  return customAxios<postPerformanceReviewRoundsIdTransitionsTargetStageResponse>(getPostPerformanceReviewRoundsIdTransitionsTargetStageUrl(id,targetStage),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostPerformanceReviewRoundsIdTransitionsTargetStageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRoundsIdTransitionsTargetStage>>, TError,{id: string;targetStage: 'collect-essay' | 'collect-feedback' | 'summary' | 'finished' | 'archived'}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRoundsIdTransitionsTargetStage>>, TError,{id: string;targetStage: 'collect-essay' | 'collect-feedback' | 'summary' | 'finished' | 'archived'}, TContext> => {

const mutationKey = ['postPerformanceReviewRoundsIdTransitionsTargetStage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPerformanceReviewRoundsIdTransitionsTargetStage>>, {id: string;targetStage: 'collect-essay' | 'collect-feedback' | 'summary' | 'finished' | 'archived'}> = (props) => {
          const {id,targetStage} = props ?? {};

          return  postPerformanceReviewRoundsIdTransitionsTargetStage(id,targetStage,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPerformanceReviewRoundsIdTransitionsTargetStageMutationResult = NonNullable<Awaited<ReturnType<typeof postPerformanceReviewRoundsIdTransitionsTargetStage>>>

    export type PostPerformanceReviewRoundsIdTransitionsTargetStageMutationError = unknown

    /**
 * @summary Transition round to target stage (admin)
 */
export const usePostPerformanceReviewRoundsIdTransitionsTargetStage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRoundsIdTransitionsTargetStage>>, TError,{id: string;targetStage: 'collect-essay' | 'collect-feedback' | 'summary' | 'finished' | 'archived'}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPerformanceReviewRoundsIdTransitionsTargetStage>>,
        TError,
        {id: string;targetStage: 'collect-essay' | 'collect-feedback' | 'summary' | 'finished' | 'archived'},
        TContext
      > => {
      return useMutation(getPostPerformanceReviewRoundsIdTransitionsTargetStageMutationOptions(options), queryClient);
    }
    export type getPerformanceReviewRoundsIdProgressResponse200 = {
  data: void
  status: 200
}

export type getPerformanceReviewRoundsIdProgressResponseSuccess = (getPerformanceReviewRoundsIdProgressResponse200) & {
  headers: Headers;
};
;

export type getPerformanceReviewRoundsIdProgressResponse = (getPerformanceReviewRoundsIdProgressResponseSuccess)

export const getGetPerformanceReviewRoundsIdProgressUrl = (id: string,) => {




  return `/performance-review/rounds/${id}/progress`
}

/**
 * @summary Get progress counters for a round (admin)
 */
export const getPerformanceReviewRoundsIdProgress = async (id: string, options?: RequestInit): Promise<getPerformanceReviewRoundsIdProgressResponse> => {

  return customAxios<getPerformanceReviewRoundsIdProgressResponse>(getGetPerformanceReviewRoundsIdProgressUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerformanceReviewRoundsIdProgressQueryKey = (id: string,) => {
    return [
    `/performance-review/rounds/${id}/progress`
    ] as const;
    }


export const getGetPerformanceReviewRoundsIdProgressQueryOptions = <TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsIdProgress>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsIdProgress>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReviewRoundsIdProgressQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerformanceReviewRoundsIdProgress>>> = ({ signal }) => getPerformanceReviewRoundsIdProgress(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsIdProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReviewRoundsIdProgressQueryResult = NonNullable<Awaited<ReturnType<typeof getPerformanceReviewRoundsIdProgress>>>
export type GetPerformanceReviewRoundsIdProgressQueryError = unknown


export function useGetPerformanceReviewRoundsIdProgress<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsIdProgress>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsIdProgress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsIdProgress>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsIdProgress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsIdProgress<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsIdProgress>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsIdProgress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsIdProgress>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsIdProgress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsIdProgress<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsIdProgress>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsIdProgress>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get progress counters for a round (admin)
 */

export function useGetPerformanceReviewRoundsIdProgress<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsIdProgress>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsIdProgress>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPerformanceReviewRoundsIdProgressQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getPerformanceReviewRoundsIdResultsResponse200 = {
  data: void
  status: 200
}

export type getPerformanceReviewRoundsIdResultsResponseSuccess = (getPerformanceReviewRoundsIdResultsResponse200) & {
  headers: Headers;
};
;

export type getPerformanceReviewRoundsIdResultsResponse = (getPerformanceReviewRoundsIdResultsResponseSuccess)

export const getGetPerformanceReviewRoundsIdResultsUrl = (id: string,) => {




  return `/performance-review/rounds/${id}/results`
}

/**
 * @summary Get aggregated results for a finished round
 */
export const getPerformanceReviewRoundsIdResults = async (id: string, options?: RequestInit): Promise<getPerformanceReviewRoundsIdResultsResponse> => {

  return customAxios<getPerformanceReviewRoundsIdResultsResponse>(getGetPerformanceReviewRoundsIdResultsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerformanceReviewRoundsIdResultsQueryKey = (id: string,) => {
    return [
    `/performance-review/rounds/${id}/results`
    ] as const;
    }


export const getGetPerformanceReviewRoundsIdResultsQueryOptions = <TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsIdResults>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsIdResults>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReviewRoundsIdResultsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerformanceReviewRoundsIdResults>>> = ({ signal }) => getPerformanceReviewRoundsIdResults(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsIdResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReviewRoundsIdResultsQueryResult = NonNullable<Awaited<ReturnType<typeof getPerformanceReviewRoundsIdResults>>>
export type GetPerformanceReviewRoundsIdResultsQueryError = unknown


export function useGetPerformanceReviewRoundsIdResults<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsIdResults>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsIdResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsIdResults>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsIdResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsIdResults<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsIdResults>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsIdResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsIdResults>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsIdResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsIdResults<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsIdResults>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsIdResults>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get aggregated results for a finished round
 */

export function useGetPerformanceReviewRoundsIdResults<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsIdResults>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsIdResults>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPerformanceReviewRoundsIdResultsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type postPerformanceReviewRoundsRoundIdParticipantsResponse201 = {
  data: void
  status: 201
}

export type postPerformanceReviewRoundsRoundIdParticipantsResponseSuccess = (postPerformanceReviewRoundsRoundIdParticipantsResponse201) & {
  headers: Headers;
};
;

export type postPerformanceReviewRoundsRoundIdParticipantsResponse = (postPerformanceReviewRoundsRoundIdParticipantsResponseSuccess)

export const getPostPerformanceReviewRoundsRoundIdParticipantsUrl = (roundId: string,) => {




  return `/performance-review/rounds/${roundId}/participants`
}

/**
 * @summary Add participant to a draft round (admin)
 */
export const postPerformanceReviewRoundsRoundIdParticipants = async (roundId: string,
    postPerformanceReviewRoundsRoundIdParticipantsBody: PostPerformanceReviewRoundsRoundIdParticipantsBody, options?: RequestInit): Promise<postPerformanceReviewRoundsRoundIdParticipantsResponse> => {

  return customAxios<postPerformanceReviewRoundsRoundIdParticipantsResponse>(getPostPerformanceReviewRoundsRoundIdParticipantsUrl(roundId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postPerformanceReviewRoundsRoundIdParticipantsBody,)
  }
);}




export const getPostPerformanceReviewRoundsRoundIdParticipantsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipants>>, TError,{roundId: string;data: PostPerformanceReviewRoundsRoundIdParticipantsBody}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipants>>, TError,{roundId: string;data: PostPerformanceReviewRoundsRoundIdParticipantsBody}, TContext> => {

const mutationKey = ['postPerformanceReviewRoundsRoundIdParticipants'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipants>>, {roundId: string;data: PostPerformanceReviewRoundsRoundIdParticipantsBody}> = (props) => {
          const {roundId,data} = props ?? {};

          return  postPerformanceReviewRoundsRoundIdParticipants(roundId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPerformanceReviewRoundsRoundIdParticipantsMutationResult = NonNullable<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipants>>>
    export type PostPerformanceReviewRoundsRoundIdParticipantsMutationBody = PostPerformanceReviewRoundsRoundIdParticipantsBody
    export type PostPerformanceReviewRoundsRoundIdParticipantsMutationError = unknown

    /**
 * @summary Add participant to a draft round (admin)
 */
export const usePostPerformanceReviewRoundsRoundIdParticipants = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipants>>, TError,{roundId: string;data: PostPerformanceReviewRoundsRoundIdParticipantsBody}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipants>>,
        TError,
        {roundId: string;data: PostPerformanceReviewRoundsRoundIdParticipantsBody},
        TContext
      > => {
      return useMutation(getPostPerformanceReviewRoundsRoundIdParticipantsMutationOptions(options), queryClient);
    }
    export type getPerformanceReviewRoundsRoundIdParticipantsResponse200 = {
  data: void
  status: 200
}

export type getPerformanceReviewRoundsRoundIdParticipantsResponseSuccess = (getPerformanceReviewRoundsRoundIdParticipantsResponse200) & {
  headers: Headers;
};
;

export type getPerformanceReviewRoundsRoundIdParticipantsResponse = (getPerformanceReviewRoundsRoundIdParticipantsResponseSuccess)

export const getGetPerformanceReviewRoundsRoundIdParticipantsUrl = (roundId: string,) => {




  return `/performance-review/rounds/${roundId}/participants`
}

/**
 * @summary List participants of a round
 */
export const getPerformanceReviewRoundsRoundIdParticipants = async (roundId: string, options?: RequestInit): Promise<getPerformanceReviewRoundsRoundIdParticipantsResponse> => {

  return customAxios<getPerformanceReviewRoundsRoundIdParticipantsResponse>(getGetPerformanceReviewRoundsRoundIdParticipantsUrl(roundId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerformanceReviewRoundsRoundIdParticipantsQueryKey = (roundId: string,) => {
    return [
    `/performance-review/rounds/${roundId}/participants`
    ] as const;
    }


export const getGetPerformanceReviewRoundsRoundIdParticipantsQueryOptions = <TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipants>>, TError = unknown>(roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipants>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReviewRoundsRoundIdParticipantsQueryKey(roundId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipants>>> = ({ signal }) => getPerformanceReviewRoundsRoundIdParticipants(roundId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(roundId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReviewRoundsRoundIdParticipantsQueryResult = NonNullable<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipants>>>
export type GetPerformanceReviewRoundsRoundIdParticipantsQueryError = unknown


export function useGetPerformanceReviewRoundsRoundIdParticipants<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipants>>, TError = unknown>(
 roundId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipants>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdParticipants<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipants>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipants>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdParticipants<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipants>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipants>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List participants of a round
 */

export function useGetPerformanceReviewRoundsRoundIdParticipants<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipants>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipants>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPerformanceReviewRoundsRoundIdParticipantsQueryOptions(roundId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type deletePerformanceReviewRoundsRoundIdParticipantsUserIdResponse204 = {
  data: void
  status: 204
}

export type deletePerformanceReviewRoundsRoundIdParticipantsUserIdResponseSuccess = (deletePerformanceReviewRoundsRoundIdParticipantsUserIdResponse204) & {
  headers: Headers;
};
;

export type deletePerformanceReviewRoundsRoundIdParticipantsUserIdResponse = (deletePerformanceReviewRoundsRoundIdParticipantsUserIdResponseSuccess)

export const getDeletePerformanceReviewRoundsRoundIdParticipantsUserIdUrl = (roundId: string,
    userId: string,) => {




  return `/performance-review/rounds/${roundId}/participants/${userId}`
}

/**
 * @summary Remove participant from a draft round (admin)
 */
export const deletePerformanceReviewRoundsRoundIdParticipantsUserId = async (roundId: string,
    userId: string, options?: RequestInit): Promise<deletePerformanceReviewRoundsRoundIdParticipantsUserIdResponse> => {

  return customAxios<deletePerformanceReviewRoundsRoundIdParticipantsUserIdResponse>(getDeletePerformanceReviewRoundsRoundIdParticipantsUserIdUrl(roundId,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePerformanceReviewRoundsRoundIdParticipantsUserIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerformanceReviewRoundsRoundIdParticipantsUserId>>, TError,{roundId: string;userId: string}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePerformanceReviewRoundsRoundIdParticipantsUserId>>, TError,{roundId: string;userId: string}, TContext> => {

const mutationKey = ['deletePerformanceReviewRoundsRoundIdParticipantsUserId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePerformanceReviewRoundsRoundIdParticipantsUserId>>, {roundId: string;userId: string}> = (props) => {
          const {roundId,userId} = props ?? {};

          return  deletePerformanceReviewRoundsRoundIdParticipantsUserId(roundId,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePerformanceReviewRoundsRoundIdParticipantsUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof deletePerformanceReviewRoundsRoundIdParticipantsUserId>>>

    export type DeletePerformanceReviewRoundsRoundIdParticipantsUserIdMutationError = unknown

    /**
 * @summary Remove participant from a draft round (admin)
 */
export const useDeletePerformanceReviewRoundsRoundIdParticipantsUserId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerformanceReviewRoundsRoundIdParticipantsUserId>>, TError,{roundId: string;userId: string}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePerformanceReviewRoundsRoundIdParticipantsUserId>>,
        TError,
        {roundId: string;userId: string},
        TContext
      > => {
      return useMutation(getDeletePerformanceReviewRoundsRoundIdParticipantsUserIdMutationOptions(options), queryClient);
    }
    export type getPerformanceReviewRoundsRoundIdSummarizersResponse200 = {
  data: GetPerformanceReviewRoundsRoundIdSummarizers200Item[]
  status: 200
}

export type getPerformanceReviewRoundsRoundIdSummarizersResponseSuccess = (getPerformanceReviewRoundsRoundIdSummarizersResponse200) & {
  headers: Headers;
};
;

export type getPerformanceReviewRoundsRoundIdSummarizersResponse = (getPerformanceReviewRoundsRoundIdSummarizersResponseSuccess)

export const getGetPerformanceReviewRoundsRoundIdSummarizersUrl = (roundId: string,) => {




  return `/performance-review/rounds/${roundId}/summarizers`
}

/**
 * @summary List who is responsible for each participant's summary (admin)
 */
export const getPerformanceReviewRoundsRoundIdSummarizers = async (roundId: string, options?: RequestInit): Promise<getPerformanceReviewRoundsRoundIdSummarizersResponse> => {

  return customAxios<getPerformanceReviewRoundsRoundIdSummarizersResponse>(getGetPerformanceReviewRoundsRoundIdSummarizersUrl(roundId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerformanceReviewRoundsRoundIdSummarizersQueryKey = (roundId: string,) => {
    return [
    `/performance-review/rounds/${roundId}/summarizers`
    ] as const;
    }


export const getGetPerformanceReviewRoundsRoundIdSummarizersQueryOptions = <TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizers>>, TError = unknown>(roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizers>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReviewRoundsRoundIdSummarizersQueryKey(roundId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizers>>> = ({ signal }) => getPerformanceReviewRoundsRoundIdSummarizers(roundId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(roundId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReviewRoundsRoundIdSummarizersQueryResult = NonNullable<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizers>>>
export type GetPerformanceReviewRoundsRoundIdSummarizersQueryError = unknown


export function useGetPerformanceReviewRoundsRoundIdSummarizers<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizers>>, TError = unknown>(
 roundId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizers>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdSummarizers<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizers>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizers>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdSummarizers<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizers>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizers>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List who is responsible for each participant's summary (admin)
 */

export function useGetPerformanceReviewRoundsRoundIdSummarizers<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizers>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizers>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPerformanceReviewRoundsRoundIdSummarizersQueryOptions(roundId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getPerformanceReviewRoundsRoundIdSummarizersMineResponse200 = {
  data: GetPerformanceReviewRoundsRoundIdSummarizersMine200Item[]
  status: 200
}

export type getPerformanceReviewRoundsRoundIdSummarizersMineResponseSuccess = (getPerformanceReviewRoundsRoundIdSummarizersMineResponse200) & {
  headers: Headers;
};
;

export type getPerformanceReviewRoundsRoundIdSummarizersMineResponse = (getPerformanceReviewRoundsRoundIdSummarizersMineResponseSuccess)

export const getGetPerformanceReviewRoundsRoundIdSummarizersMineUrl = (roundId: string,) => {




  return `/performance-review/rounds/${roundId}/summarizers/mine`
}

/**
 * @summary Participants the caller is responsible for summarizing in this round
 */
export const getPerformanceReviewRoundsRoundIdSummarizersMine = async (roundId: string, options?: RequestInit): Promise<getPerformanceReviewRoundsRoundIdSummarizersMineResponse> => {

  return customAxios<getPerformanceReviewRoundsRoundIdSummarizersMineResponse>(getGetPerformanceReviewRoundsRoundIdSummarizersMineUrl(roundId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerformanceReviewRoundsRoundIdSummarizersMineQueryKey = (roundId: string,) => {
    return [
    `/performance-review/rounds/${roundId}/summarizers/mine`
    ] as const;
    }


export const getGetPerformanceReviewRoundsRoundIdSummarizersMineQueryOptions = <TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizersMine>>, TError = unknown>(roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizersMine>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReviewRoundsRoundIdSummarizersMineQueryKey(roundId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizersMine>>> = ({ signal }) => getPerformanceReviewRoundsRoundIdSummarizersMine(roundId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(roundId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizersMine>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReviewRoundsRoundIdSummarizersMineQueryResult = NonNullable<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizersMine>>>
export type GetPerformanceReviewRoundsRoundIdSummarizersMineQueryError = unknown


export function useGetPerformanceReviewRoundsRoundIdSummarizersMine<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizersMine>>, TError = unknown>(
 roundId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizersMine>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizersMine>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizersMine>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdSummarizersMine<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizersMine>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizersMine>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizersMine>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizersMine>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdSummarizersMine<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizersMine>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizersMine>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Participants the caller is responsible for summarizing in this round
 */

export function useGetPerformanceReviewRoundsRoundIdSummarizersMine<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizersMine>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSummarizersMine>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPerformanceReviewRoundsRoundIdSummarizersMineQueryOptions(roundId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type putPerformanceReviewRoundsRoundIdSummarizersUserIdResponse200 = {
  data: void
  status: 200
}

export type putPerformanceReviewRoundsRoundIdSummarizersUserIdResponseSuccess = (putPerformanceReviewRoundsRoundIdSummarizersUserIdResponse200) & {
  headers: Headers;
};
;

export type putPerformanceReviewRoundsRoundIdSummarizersUserIdResponse = (putPerformanceReviewRoundsRoundIdSummarizersUserIdResponseSuccess)

export const getPutPerformanceReviewRoundsRoundIdSummarizersUserIdUrl = (roundId: string,
    userId: string,) => {




  return `/performance-review/rounds/${roundId}/summarizers/${userId}`
}

/**
 * @summary Assign or clear the summarizer of one participant (admin)
 */
export const putPerformanceReviewRoundsRoundIdSummarizersUserId = async (roundId: string,
    userId: string,
    putPerformanceReviewRoundsRoundIdSummarizersUserIdBody: PutPerformanceReviewRoundsRoundIdSummarizersUserIdBody, options?: RequestInit): Promise<putPerformanceReviewRoundsRoundIdSummarizersUserIdResponse> => {

  return customAxios<putPerformanceReviewRoundsRoundIdSummarizersUserIdResponse>(getPutPerformanceReviewRoundsRoundIdSummarizersUserIdUrl(roundId,userId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putPerformanceReviewRoundsRoundIdSummarizersUserIdBody,)
  }
);}




export const getPutPerformanceReviewRoundsRoundIdSummarizersUserIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPerformanceReviewRoundsRoundIdSummarizersUserId>>, TError,{roundId: string;userId: string;data: PutPerformanceReviewRoundsRoundIdSummarizersUserIdBody}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof putPerformanceReviewRoundsRoundIdSummarizersUserId>>, TError,{roundId: string;userId: string;data: PutPerformanceReviewRoundsRoundIdSummarizersUserIdBody}, TContext> => {

const mutationKey = ['putPerformanceReviewRoundsRoundIdSummarizersUserId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPerformanceReviewRoundsRoundIdSummarizersUserId>>, {roundId: string;userId: string;data: PutPerformanceReviewRoundsRoundIdSummarizersUserIdBody}> = (props) => {
          const {roundId,userId,data} = props ?? {};

          return  putPerformanceReviewRoundsRoundIdSummarizersUserId(roundId,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutPerformanceReviewRoundsRoundIdSummarizersUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof putPerformanceReviewRoundsRoundIdSummarizersUserId>>>
    export type PutPerformanceReviewRoundsRoundIdSummarizersUserIdMutationBody = PutPerformanceReviewRoundsRoundIdSummarizersUserIdBody
    export type PutPerformanceReviewRoundsRoundIdSummarizersUserIdMutationError = unknown

    /**
 * @summary Assign or clear the summarizer of one participant (admin)
 */
export const usePutPerformanceReviewRoundsRoundIdSummarizersUserId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPerformanceReviewRoundsRoundIdSummarizersUserId>>, TError,{roundId: string;userId: string;data: PutPerformanceReviewRoundsRoundIdSummarizersUserIdBody}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPerformanceReviewRoundsRoundIdSummarizersUserId>>,
        TError,
        {roundId: string;userId: string;data: PutPerformanceReviewRoundsRoundIdSummarizersUserIdBody},
        TContext
      > => {
      return useMutation(getPutPerformanceReviewRoundsRoundIdSummarizersUserIdMutationOptions(options), queryClient);
    }
    export type postPerformanceReviewRoundsRoundIdSummarizersRecomputeResponse200 = {
  data: void
  status: 200
}

export type postPerformanceReviewRoundsRoundIdSummarizersRecomputeResponseSuccess = (postPerformanceReviewRoundsRoundIdSummarizersRecomputeResponse200) & {
  headers: Headers;
};
;

export type postPerformanceReviewRoundsRoundIdSummarizersRecomputeResponse = (postPerformanceReviewRoundsRoundIdSummarizersRecomputeResponseSuccess)

export const getPostPerformanceReviewRoundsRoundIdSummarizersRecomputeUrl = (roundId: string,) => {




  return `/performance-review/rounds/${roundId}/summarizers/recompute`
}

/**
 * @summary Fill in the summarizer of everyone still unassigned (admin)
 */
export const postPerformanceReviewRoundsRoundIdSummarizersRecompute = async (roundId: string, options?: RequestInit): Promise<postPerformanceReviewRoundsRoundIdSummarizersRecomputeResponse> => {

  return customAxios<postPerformanceReviewRoundsRoundIdSummarizersRecomputeResponse>(getPostPerformanceReviewRoundsRoundIdSummarizersRecomputeUrl(roundId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostPerformanceReviewRoundsRoundIdSummarizersRecomputeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdSummarizersRecompute>>, TError,{roundId: string}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdSummarizersRecompute>>, TError,{roundId: string}, TContext> => {

const mutationKey = ['postPerformanceReviewRoundsRoundIdSummarizersRecompute'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdSummarizersRecompute>>, {roundId: string}> = (props) => {
          const {roundId} = props ?? {};

          return  postPerformanceReviewRoundsRoundIdSummarizersRecompute(roundId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPerformanceReviewRoundsRoundIdSummarizersRecomputeMutationResult = NonNullable<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdSummarizersRecompute>>>

    export type PostPerformanceReviewRoundsRoundIdSummarizersRecomputeMutationError = unknown

    /**
 * @summary Fill in the summarizer of everyone still unassigned (admin)
 */
export const usePostPerformanceReviewRoundsRoundIdSummarizersRecompute = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdSummarizersRecompute>>, TError,{roundId: string}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdSummarizersRecompute>>,
        TError,
        {roundId: string},
        TContext
      > => {
      return useMutation(getPostPerformanceReviewRoundsRoundIdSummarizersRecomputeMutationOptions(options), queryClient);
    }
    export type postPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundIdResponse200 = {
  data: void
  status: 200
}

export type postPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundIdResponseSuccess = (postPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundIdResponse200) & {
  headers: Headers;
};
;

export type postPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundIdResponse = (postPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundIdResponseSuccess)

export const getPostPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundIdUrl = (roundId: string,
    sourceRoundId: string,) => {




  return `/performance-review/rounds/${roundId}/summarizers/copy-from/${sourceRoundId}`
}

/**
 * @summary Copy assignments from an earlier round, filling only the blanks (admin)
 */
export const postPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundId = async (roundId: string,
    sourceRoundId: string, options?: RequestInit): Promise<postPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundIdResponse> => {

  return customAxios<postPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundIdResponse>(getPostPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundIdUrl(roundId,sourceRoundId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundId>>, TError,{roundId: string;sourceRoundId: string}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundId>>, TError,{roundId: string;sourceRoundId: string}, TContext> => {

const mutationKey = ['postPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundId>>, {roundId: string;sourceRoundId: string}> = (props) => {
          const {roundId,sourceRoundId} = props ?? {};

          return  postPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundId(roundId,sourceRoundId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundIdMutationResult = NonNullable<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundId>>>

    export type PostPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundIdMutationError = unknown

    /**
 * @summary Copy assignments from an earlier round, filling only the blanks (admin)
 */
export const usePostPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundId>>, TError,{roundId: string;sourceRoundId: string}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundId>>,
        TError,
        {roundId: string;sourceRoundId: string},
        TContext
      > => {
      return useMutation(getPostPerformanceReviewRoundsRoundIdSummarizersCopyFromSourceRoundIdMutationOptions(options), queryClient);
    }
    export type getPerformanceReviewRoundsRoundIdParticipantsMeResponse200 = {
  data: void
  status: 200
}

export type getPerformanceReviewRoundsRoundIdParticipantsMeResponseSuccess = (getPerformanceReviewRoundsRoundIdParticipantsMeResponse200) & {
  headers: Headers;
};
;

export type getPerformanceReviewRoundsRoundIdParticipantsMeResponse = (getPerformanceReviewRoundsRoundIdParticipantsMeResponseSuccess)

export const getGetPerformanceReviewRoundsRoundIdParticipantsMeUrl = (roundId: string,) => {




  return `/performance-review/rounds/${roundId}/participants/me`
}

/**
 * @summary Get current user's participant record for this round (summary blocks, meeting, decision, grades, highlights).
 */
export const getPerformanceReviewRoundsRoundIdParticipantsMe = async (roundId: string, options?: RequestInit): Promise<getPerformanceReviewRoundsRoundIdParticipantsMeResponse> => {

  return customAxios<getPerformanceReviewRoundsRoundIdParticipantsMeResponse>(getGetPerformanceReviewRoundsRoundIdParticipantsMeUrl(roundId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerformanceReviewRoundsRoundIdParticipantsMeQueryKey = (roundId: string,) => {
    return [
    `/performance-review/rounds/${roundId}/participants/me`
    ] as const;
    }


export const getGetPerformanceReviewRoundsRoundIdParticipantsMeQueryOptions = <TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipantsMe>>, TError = unknown>(roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipantsMe>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReviewRoundsRoundIdParticipantsMeQueryKey(roundId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipantsMe>>> = ({ signal }) => getPerformanceReviewRoundsRoundIdParticipantsMe(roundId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(roundId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipantsMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReviewRoundsRoundIdParticipantsMeQueryResult = NonNullable<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipantsMe>>>
export type GetPerformanceReviewRoundsRoundIdParticipantsMeQueryError = unknown


export function useGetPerformanceReviewRoundsRoundIdParticipantsMe<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipantsMe>>, TError = unknown>(
 roundId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipantsMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipantsMe>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipantsMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdParticipantsMe<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipantsMe>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipantsMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipantsMe>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipantsMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdParticipantsMe<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipantsMe>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipantsMe>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user's participant record for this round (summary blocks, meeting, decision, grades, highlights).
 */

export function useGetPerformanceReviewRoundsRoundIdParticipantsMe<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipantsMe>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdParticipantsMe>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPerformanceReviewRoundsRoundIdParticipantsMeQueryOptions(roundId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type patchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersResponse200 = {
  data: void
  status: 200
}

export type patchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersResponseSuccess = (patchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersResponse200) & {
  headers: Headers;
};
;

export type patchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersResponse = (patchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersResponseSuccess)

export const getPatchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersUrl = (roundId: string,
    userId: string,) => {




  return `/performance-review/rounds/${roundId}/participants/${userId}/requested-reviewers`
}

/**
 * @summary Participant updates list of requested peer-reviewers (self only, only during collect-essay)
 */
export const patchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewers = async (roundId: string,
    userId: string,
    patchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersBody: PatchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersBody, options?: RequestInit): Promise<patchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersResponse> => {

  return customAxios<patchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersResponse>(getPatchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersUrl(roundId,userId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersBody,)
  }
);}




export const getPatchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewers>>, TError,{roundId: string;userId: string;data: PatchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersBody}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof patchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewers>>, TError,{roundId: string;userId: string;data: PatchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersBody}, TContext> => {

const mutationKey = ['patchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewers>>, {roundId: string;userId: string;data: PatchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersBody}> = (props) => {
          const {roundId,userId,data} = props ?? {};

          return  patchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewers(roundId,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersMutationResult = NonNullable<Awaited<ReturnType<typeof patchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewers>>>
    export type PatchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersMutationBody = PatchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersBody
    export type PatchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersMutationError = unknown

    /**
 * @summary Participant updates list of requested peer-reviewers (self only, only during collect-essay)
 */
export const usePatchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewers>>, TError,{roundId: string;userId: string;data: PatchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersBody}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewers>>,
        TError,
        {roundId: string;userId: string;data: PatchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersBody},
        TContext
      > => {
      return useMutation(getPatchPerformanceReviewRoundsRoundIdParticipantsUserIdRequestedReviewersMutationOptions(options), queryClient);
    }
    export type patchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryResponse200 = {
  data: void
  status: 200
}

export type patchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryResponseSuccess = (patchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryResponse200) & {
  headers: Headers;
};
;

export type patchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryResponse = (patchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryResponseSuccess)

export const getPatchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryUrl = (roundId: string,
    userId: string,) => {




  return `/performance-review/rounds/${roundId}/participants/${userId}/summary`
}

/**
 * @summary Save the summary draft for a participant (assigned summarizer or admin)
 */
export const patchPerformanceReviewRoundsRoundIdParticipantsUserIdSummary = async (roundId: string,
    userId: string,
    patchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBody: PatchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBody, options?: RequestInit): Promise<patchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryResponse> => {

  return customAxios<patchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryResponse>(getPatchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryUrl(roundId,userId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBody,)
  }
);}




export const getPatchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPerformanceReviewRoundsRoundIdParticipantsUserIdSummary>>, TError,{roundId: string;userId: string;data: PatchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBody}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof patchPerformanceReviewRoundsRoundIdParticipantsUserIdSummary>>, TError,{roundId: string;userId: string;data: PatchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBody}, TContext> => {

const mutationKey = ['patchPerformanceReviewRoundsRoundIdParticipantsUserIdSummary'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchPerformanceReviewRoundsRoundIdParticipantsUserIdSummary>>, {roundId: string;userId: string;data: PatchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBody}> = (props) => {
          const {roundId,userId,data} = props ?? {};

          return  patchPerformanceReviewRoundsRoundIdParticipantsUserIdSummary(roundId,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryMutationResult = NonNullable<Awaited<ReturnType<typeof patchPerformanceReviewRoundsRoundIdParticipantsUserIdSummary>>>
    export type PatchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryMutationBody = PatchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBody
    export type PatchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryMutationError = unknown

    /**
 * @summary Save the summary draft for a participant (assigned summarizer or admin)
 */
export const usePatchPerformanceReviewRoundsRoundIdParticipantsUserIdSummary = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPerformanceReviewRoundsRoundIdParticipantsUserIdSummary>>, TError,{roundId: string;userId: string;data: PatchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBody}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchPerformanceReviewRoundsRoundIdParticipantsUserIdSummary>>,
        TError,
        {roundId: string;userId: string;data: PatchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBody},
        TContext
      > => {
      return useMutation(getPatchPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryMutationOptions(options), queryClient);
    }
    export type putPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksResponse200 = {
  data: void
  status: 200
}

export type putPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksResponseSuccess = (putPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksResponse200) & {
  headers: Headers;
};
;

export type putPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksResponse = (putPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksResponseSuccess)

export const getPutPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksUrl = (roundId: string,
    userId: string,) => {




  return `/performance-review/rounds/${roundId}/participants/${userId}/summary-blocks`
}

/**
 * @summary Replace per-block summary comments for a participant (assigned summarizer or admin)
 */
export const putPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocks = async (roundId: string,
    userId: string,
    putPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksBody: PutPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksBody, options?: RequestInit): Promise<putPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksResponse> => {

  return customAxios<putPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksResponse>(getPutPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksUrl(roundId,userId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksBody,)
  }
);}




export const getPutPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocks>>, TError,{roundId: string;userId: string;data: PutPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksBody}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof putPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocks>>, TError,{roundId: string;userId: string;data: PutPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksBody}, TContext> => {

const mutationKey = ['putPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocks>>, {roundId: string;userId: string;data: PutPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksBody}> = (props) => {
          const {roundId,userId,data} = props ?? {};

          return  putPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocks(roundId,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksMutationResult = NonNullable<Awaited<ReturnType<typeof putPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocks>>>
    export type PutPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksMutationBody = PutPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksBody
    export type PutPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksMutationError = unknown

    /**
 * @summary Replace per-block summary comments for a participant (assigned summarizer or admin)
 */
export const usePutPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocks = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocks>>, TError,{roundId: string;userId: string;data: PutPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksBody}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocks>>,
        TError,
        {roundId: string;userId: string;data: PutPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksBody},
        TContext
      > => {
      return useMutation(getPutPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryBlocksMutationOptions(options), queryClient);
    }
    export type postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishResponse200 = {
  data: void
  status: 200
}

export type postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishResponseSuccess = (postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishResponse200) & {
  headers: Headers;
};
;

export type postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishResponse = (postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishResponseSuccess)

export const getPostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishUrl = (roundId: string,
    userId: string,) => {




  return `/performance-review/rounds/${roundId}/participants/${userId}/summary/publish`
}

/**
 * @summary Publish summary draft (admin); auto-finishes round when last is published. Optional `blocks` body atomically saves new block comments before publishing — use this from the editor's "Publish" button to avoid the save→publish race.
 */
export const postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublish = async (roundId: string,
    userId: string,
    postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishBody?: PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishBody, options?: RequestInit): Promise<postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishResponse> => {

  return customAxios<postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishResponse>(getPostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishUrl(roundId,userId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishBody,)
  }
);}




export const getPostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublish>>, TError,{roundId: string;userId: string;data?: PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishBody}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublish>>, TError,{roundId: string;userId: string;data?: PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishBody}, TContext> => {

const mutationKey = ['postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublish'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublish>>, {roundId: string;userId: string;data?: PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishBody}> = (props) => {
          const {roundId,userId,data} = props ?? {};

          return  postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublish(roundId,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishMutationResult = NonNullable<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublish>>>
    export type PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishMutationBody = PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishBody | undefined
    export type PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishMutationError = unknown

    /**
 * @summary Publish summary draft (admin); auto-finishes round when last is published. Optional `blocks` body atomically saves new block comments before publishing — use this from the editor's "Publish" button to avoid the save→publish race.
 */
export const usePostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublish = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublish>>, TError,{roundId: string;userId: string;data?: PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishBody}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublish>>,
        TError,
        {roundId: string;userId: string;data?: PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishBody},
        TContext
      > => {
      return useMutation(getPostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishMutationOptions(options), queryClient);
    }
    export type deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishResponse200 = {
  data: void
  status: 200
}

export type deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishResponse409 = {
  data: void
  status: 409
}

export type deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishResponseSuccess = (deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishResponse200) & {
  headers: Headers;
};
export type deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishResponseError = (deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishResponse409) & {
  headers: Headers;
};

export type deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishResponse = (deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishResponseSuccess | deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishResponseError)

export const getDeletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishUrl = (roundId: string,
    userId: string,) => {




  return `/performance-review/rounds/${roundId}/participants/${userId}/summary/publish`
}

/**
 * @summary Retract a published summary — it becomes a draft again and disappears from the subject's view (admin). Does not unsend the notification email.
 */
export const deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublish = async (roundId: string,
    userId: string, options?: RequestInit): Promise<deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishResponse> => {

  return customAxios<deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishResponse>(getDeletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishUrl(roundId,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublish>>, TError,{roundId: string;userId: string}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublish>>, TError,{roundId: string;userId: string}, TContext> => {

const mutationKey = ['deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublish'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublish>>, {roundId: string;userId: string}> = (props) => {
          const {roundId,userId} = props ?? {};

          return  deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublish(roundId,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishMutationResult = NonNullable<Awaited<ReturnType<typeof deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublish>>>

    export type DeletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishMutationError = void

    /**
 * @summary Retract a published summary — it becomes a draft again and disappears from the subject's view (admin). Does not unsend the notification email.
 */
export const useDeletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublish = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublish>>, TError,{roundId: string;userId: string}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublish>>,
        TError,
        {roundId: string;userId: string},
        TContext
      > => {
      return useMutation(getDeletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryPublishMutationOptions(options), queryClient);
    }
    export type postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponse200 = {
  data: void
  status: 200
}

export type postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponse409 = {
  data: void
  status: 409
}

export type postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponseSuccess = (postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponse200) & {
  headers: Headers;
};
export type postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponseError = (postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponse409) & {
  headers: Headers;
};

export type postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponse = (postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponseSuccess | postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponseError)

export const getPostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareUrl = (roundId: string,
    userId: string,) => {




  return `/performance-review/rounds/${roundId}/participants/${userId}/summary/share`
}

/**
 * @summary Pre-publish a summary to the subject's lead/PM only (admin). The subject sees nothing until publish. Optional `blocks` body saves the block comments first, like publish does.
 */
export const postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShare = async (roundId: string,
    userId: string,
    postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareBody?: PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareBody, options?: RequestInit): Promise<postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponse> => {

  return customAxios<postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponse>(getPostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareUrl(roundId,userId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareBody,)
  }
);}




export const getPostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShare>>, TError,{roundId: string;userId: string;data?: PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareBody}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShare>>, TError,{roundId: string;userId: string;data?: PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareBody}, TContext> => {

const mutationKey = ['postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShare'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShare>>, {roundId: string;userId: string;data?: PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareBody}> = (props) => {
          const {roundId,userId,data} = props ?? {};

          return  postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShare(roundId,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareMutationResult = NonNullable<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShare>>>
    export type PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareMutationBody = PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareBody | undefined
    export type PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareMutationError = void

    /**
 * @summary Pre-publish a summary to the subject's lead/PM only (admin). The subject sees nothing until publish. Optional `blocks` body saves the block comments first, like publish does.
 */
export const usePostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShare = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShare>>, TError,{roundId: string;userId: string;data?: PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareBody}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShare>>,
        TError,
        {roundId: string;userId: string;data?: PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareBody},
        TContext
      > => {
      return useMutation(getPostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareMutationOptions(options), queryClient);
    }
    export type deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponse200 = {
  data: void
  status: 200
}

export type deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponse409 = {
  data: void
  status: 409
}

export type deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponseSuccess = (deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponse200) & {
  headers: Headers;
};
export type deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponseError = (deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponse409) & {
  headers: Headers;
};

export type deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponse = (deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponseSuccess | deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponseError)

export const getDeletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareUrl = (roundId: string,
    userId: string,) => {




  return `/performance-review/rounds/${roundId}/participants/${userId}/summary/share`
}

/**
 * @summary Retract the pre-publication (admin) — the summary leaves the lead's/PM's view as well as the subject's, and is a plain draft again.
 */
export const deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShare = async (roundId: string,
    userId: string, options?: RequestInit): Promise<deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponse> => {

  return customAxios<deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareResponse>(getDeletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareUrl(roundId,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShare>>, TError,{roundId: string;userId: string}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShare>>, TError,{roundId: string;userId: string}, TContext> => {

const mutationKey = ['deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShare'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShare>>, {roundId: string;userId: string}> = (props) => {
          const {roundId,userId} = props ?? {};

          return  deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShare(roundId,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareMutationResult = NonNullable<Awaited<ReturnType<typeof deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShare>>>

    export type DeletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareMutationError = void

    /**
 * @summary Retract the pre-publication (admin) — the summary leaves the lead's/PM's view as well as the subject's, and is a plain draft again.
 */
export const useDeletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShare = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShare>>, TError,{roundId: string;userId: string}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShare>>,
        TError,
        {roundId: string;userId: string},
        TContext
      > => {
      return useMutation(getDeletePerformanceReviewRoundsRoundIdParticipantsUserIdSummaryShareMutationOptions(options), queryClient);
    }
    export type postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraftResponse200 = {
  data: void
  status: 200
}

export type postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraftResponseSuccess = (postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraftResponse200) & {
  headers: Headers;
};
;

export type postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraftResponse = (postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraftResponseSuccess)

export const getPostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraftUrl = (roundId: string,
    userId: string,) => {




  return `/performance-review/rounds/${roundId}/participants/${userId}/summary/ai-draft`
}

/**
 * @summary Generate an AI draft summary per block from the subject's feedback (admin)
 */
export const postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraft = async (roundId: string,
    userId: string, options?: RequestInit): Promise<postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraftResponse> => {

  return customAxios<postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraftResponse>(getPostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraftUrl(roundId,userId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraftMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraft>>, TError,{roundId: string;userId: string}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraft>>, TError,{roundId: string;userId: string}, TContext> => {

const mutationKey = ['postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraft>>, {roundId: string;userId: string}> = (props) => {
          const {roundId,userId} = props ?? {};

          return  postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraft(roundId,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraftMutationResult = NonNullable<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraft>>>

    export type PostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraftMutationError = unknown

    /**
 * @summary Generate an AI draft summary per block from the subject's feedback (admin)
 */
export const usePostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraft = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraft>>, TError,{roundId: string;userId: string}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraft>>,
        TError,
        {roundId: string;userId: string},
        TContext
      > => {
      return useMutation(getPostPerformanceReviewRoundsRoundIdParticipantsUserIdSummaryAiDraftMutationOptions(options), queryClient);
    }
    export type getPerformanceReviewRoundsRoundIdFormsMineResponse200 = {
  data: void
  status: 200
}

export type getPerformanceReviewRoundsRoundIdFormsMineResponseSuccess = (getPerformanceReviewRoundsRoundIdFormsMineResponse200) & {
  headers: Headers;
};
;

export type getPerformanceReviewRoundsRoundIdFormsMineResponse = (getPerformanceReviewRoundsRoundIdFormsMineResponseSuccess)

export const getGetPerformanceReviewRoundsRoundIdFormsMineUrl = (roundId: string,) => {




  return `/performance-review/rounds/${roundId}/forms/mine`
}

/**
 * @summary List forms where current user is respondent
 */
export const getPerformanceReviewRoundsRoundIdFormsMine = async (roundId: string, options?: RequestInit): Promise<getPerformanceReviewRoundsRoundIdFormsMineResponse> => {

  return customAxios<getPerformanceReviewRoundsRoundIdFormsMineResponse>(getGetPerformanceReviewRoundsRoundIdFormsMineUrl(roundId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerformanceReviewRoundsRoundIdFormsMineQueryKey = (roundId: string,) => {
    return [
    `/performance-review/rounds/${roundId}/forms/mine`
    ] as const;
    }


export const getGetPerformanceReviewRoundsRoundIdFormsMineQueryOptions = <TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsMine>>, TError = unknown>(roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsMine>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReviewRoundsRoundIdFormsMineQueryKey(roundId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsMine>>> = ({ signal }) => getPerformanceReviewRoundsRoundIdFormsMine(roundId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(roundId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsMine>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReviewRoundsRoundIdFormsMineQueryResult = NonNullable<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsMine>>>
export type GetPerformanceReviewRoundsRoundIdFormsMineQueryError = unknown


export function useGetPerformanceReviewRoundsRoundIdFormsMine<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsMine>>, TError = unknown>(
 roundId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsMine>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsMine>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsMine>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdFormsMine<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsMine>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsMine>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsMine>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsMine>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdFormsMine<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsMine>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsMine>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List forms where current user is respondent
 */

export function useGetPerformanceReviewRoundsRoundIdFormsMine<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsMine>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsMine>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPerformanceReviewRoundsRoundIdFormsMineQueryOptions(roundId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getPerformanceReviewRoundsRoundIdFormsAboutMeResponse200 = {
  data: GetPerformanceReviewRoundsRoundIdFormsAboutMe200Item[]
  status: 200
}

export type getPerformanceReviewRoundsRoundIdFormsAboutMeResponseSuccess = (getPerformanceReviewRoundsRoundIdFormsAboutMeResponse200) & {
  headers: Headers;
};
;

export type getPerformanceReviewRoundsRoundIdFormsAboutMeResponse = (getPerformanceReviewRoundsRoundIdFormsAboutMeResponseSuccess)

export const getGetPerformanceReviewRoundsRoundIdFormsAboutMeUrl = (roundId: string,) => {




  return `/performance-review/rounds/${roundId}/forms/about-me`
}

/**
 * @summary Peer-форм где текущий юзер — subject. Возвращает только типы и статусы форм — БЕЗ личности ревьюеров (peer review анонимен для subject).
 */
export const getPerformanceReviewRoundsRoundIdFormsAboutMe = async (roundId: string, options?: RequestInit): Promise<getPerformanceReviewRoundsRoundIdFormsAboutMeResponse> => {

  return customAxios<getPerformanceReviewRoundsRoundIdFormsAboutMeResponse>(getGetPerformanceReviewRoundsRoundIdFormsAboutMeUrl(roundId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerformanceReviewRoundsRoundIdFormsAboutMeQueryKey = (roundId: string,) => {
    return [
    `/performance-review/rounds/${roundId}/forms/about-me`
    ] as const;
    }


export const getGetPerformanceReviewRoundsRoundIdFormsAboutMeQueryOptions = <TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsAboutMe>>, TError = unknown>(roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsAboutMe>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReviewRoundsRoundIdFormsAboutMeQueryKey(roundId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsAboutMe>>> = ({ signal }) => getPerformanceReviewRoundsRoundIdFormsAboutMe(roundId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(roundId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsAboutMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReviewRoundsRoundIdFormsAboutMeQueryResult = NonNullable<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsAboutMe>>>
export type GetPerformanceReviewRoundsRoundIdFormsAboutMeQueryError = unknown


export function useGetPerformanceReviewRoundsRoundIdFormsAboutMe<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsAboutMe>>, TError = unknown>(
 roundId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsAboutMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsAboutMe>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsAboutMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdFormsAboutMe<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsAboutMe>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsAboutMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsAboutMe>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsAboutMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdFormsAboutMe<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsAboutMe>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsAboutMe>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Peer-форм где текущий юзер — subject. Возвращает только типы и статусы форм — БЕЗ личности ревьюеров (peer review анонимен для subject).
 */

export function useGetPerformanceReviewRoundsRoundIdFormsAboutMe<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsAboutMe>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdFormsAboutMe>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPerformanceReviewRoundsRoundIdFormsAboutMeQueryOptions(roundId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getPerformanceReviewFormsIdResponse200 = {
  data: void
  status: 200
}

export type getPerformanceReviewFormsIdResponseSuccess = (getPerformanceReviewFormsIdResponse200) & {
  headers: Headers;
};
;

export type getPerformanceReviewFormsIdResponse = (getPerformanceReviewFormsIdResponseSuccess)

export const getGetPerformanceReviewFormsIdUrl = (id: string,) => {




  return `/performance-review/forms/${id}`
}

/**
 * @summary Get a single form (respondent or admin only)
 */
export const getPerformanceReviewFormsId = async (id: string, options?: RequestInit): Promise<getPerformanceReviewFormsIdResponse> => {

  return customAxios<getPerformanceReviewFormsIdResponse>(getGetPerformanceReviewFormsIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerformanceReviewFormsIdQueryKey = (id: string,) => {
    return [
    `/performance-review/forms/${id}`
    ] as const;
    }


export const getGetPerformanceReviewFormsIdQueryOptions = <TData = Awaited<ReturnType<typeof getPerformanceReviewFormsId>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewFormsId>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReviewFormsIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerformanceReviewFormsId>>> = ({ signal }) => getPerformanceReviewFormsId(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewFormsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReviewFormsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPerformanceReviewFormsId>>>
export type GetPerformanceReviewFormsIdQueryError = unknown


export function useGetPerformanceReviewFormsId<TData = Awaited<ReturnType<typeof getPerformanceReviewFormsId>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewFormsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewFormsId>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewFormsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewFormsId<TData = Awaited<ReturnType<typeof getPerformanceReviewFormsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewFormsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewFormsId>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewFormsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewFormsId<TData = Awaited<ReturnType<typeof getPerformanceReviewFormsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewFormsId>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single form (respondent or admin only)
 */

export function useGetPerformanceReviewFormsId<TData = Awaited<ReturnType<typeof getPerformanceReviewFormsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewFormsId>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPerformanceReviewFormsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type patchPerformanceReviewFormsIdDraftResponse200 = {
  data: void
  status: 200
}

export type patchPerformanceReviewFormsIdDraftResponseSuccess = (patchPerformanceReviewFormsIdDraftResponse200) & {
  headers: Headers;
};
;

export type patchPerformanceReviewFormsIdDraftResponse = (patchPerformanceReviewFormsIdDraftResponseSuccess)

export const getPatchPerformanceReviewFormsIdDraftUrl = (id: string,) => {




  return `/performance-review/forms/${id}/draft`
}

/**
 * @summary Save form draft (respondent only)
 */
export const patchPerformanceReviewFormsIdDraft = async (id: string,
    patchPerformanceReviewFormsIdDraftBody: PatchPerformanceReviewFormsIdDraftBody, options?: RequestInit): Promise<patchPerformanceReviewFormsIdDraftResponse> => {

  return customAxios<patchPerformanceReviewFormsIdDraftResponse>(getPatchPerformanceReviewFormsIdDraftUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchPerformanceReviewFormsIdDraftBody,)
  }
);}




export const getPatchPerformanceReviewFormsIdDraftMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPerformanceReviewFormsIdDraft>>, TError,{id: string;data: PatchPerformanceReviewFormsIdDraftBody}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof patchPerformanceReviewFormsIdDraft>>, TError,{id: string;data: PatchPerformanceReviewFormsIdDraftBody}, TContext> => {

const mutationKey = ['patchPerformanceReviewFormsIdDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchPerformanceReviewFormsIdDraft>>, {id: string;data: PatchPerformanceReviewFormsIdDraftBody}> = (props) => {
          const {id,data} = props ?? {};

          return  patchPerformanceReviewFormsIdDraft(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchPerformanceReviewFormsIdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof patchPerformanceReviewFormsIdDraft>>>
    export type PatchPerformanceReviewFormsIdDraftMutationBody = PatchPerformanceReviewFormsIdDraftBody
    export type PatchPerformanceReviewFormsIdDraftMutationError = unknown

    /**
 * @summary Save form draft (respondent only)
 */
export const usePatchPerformanceReviewFormsIdDraft = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPerformanceReviewFormsIdDraft>>, TError,{id: string;data: PatchPerformanceReviewFormsIdDraftBody}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchPerformanceReviewFormsIdDraft>>,
        TError,
        {id: string;data: PatchPerformanceReviewFormsIdDraftBody},
        TContext
      > => {
      return useMutation(getPatchPerformanceReviewFormsIdDraftMutationOptions(options), queryClient);
    }
    export type postPerformanceReviewFormsIdSubmitResponse200 = {
  data: void
  status: 200
}

export type postPerformanceReviewFormsIdSubmitResponseSuccess = (postPerformanceReviewFormsIdSubmitResponse200) & {
  headers: Headers;
};
;

export type postPerformanceReviewFormsIdSubmitResponse = (postPerformanceReviewFormsIdSubmitResponseSuccess)

export const getPostPerformanceReviewFormsIdSubmitUrl = (id: string,) => {




  return `/performance-review/forms/${id}/submit`
}

/**
 * @summary Submit form (respondent only); triggers auto-stage advance
 */
export const postPerformanceReviewFormsIdSubmit = async (id: string, options?: RequestInit): Promise<postPerformanceReviewFormsIdSubmitResponse> => {

  return customAxios<postPerformanceReviewFormsIdSubmitResponse>(getPostPerformanceReviewFormsIdSubmitUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostPerformanceReviewFormsIdSubmitMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewFormsIdSubmit>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewFormsIdSubmit>>, TError,{id: string}, TContext> => {

const mutationKey = ['postPerformanceReviewFormsIdSubmit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPerformanceReviewFormsIdSubmit>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postPerformanceReviewFormsIdSubmit(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPerformanceReviewFormsIdSubmitMutationResult = NonNullable<Awaited<ReturnType<typeof postPerformanceReviewFormsIdSubmit>>>

    export type PostPerformanceReviewFormsIdSubmitMutationError = unknown

    /**
 * @summary Submit form (respondent only); triggers auto-stage advance
 */
export const usePostPerformanceReviewFormsIdSubmit = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewFormsIdSubmit>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPerformanceReviewFormsIdSubmit>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getPostPerformanceReviewFormsIdSubmitMutationOptions(options), queryClient);
    }
    export type postPerformanceReviewFormsIdReopenResponse200 = {
  data: void
  status: 200
}

export type postPerformanceReviewFormsIdReopenResponseSuccess = (postPerformanceReviewFormsIdReopenResponse200) & {
  headers: Headers;
};
;

export type postPerformanceReviewFormsIdReopenResponse = (postPerformanceReviewFormsIdReopenResponseSuccess)

export const getPostPerformanceReviewFormsIdReopenUrl = (id: string,) => {




  return `/performance-review/forms/${id}/reopen`
}

/**
 * @summary Reopen a submitted form (respondent only, while collection is open)
 */
export const postPerformanceReviewFormsIdReopen = async (id: string, options?: RequestInit): Promise<postPerformanceReviewFormsIdReopenResponse> => {

  return customAxios<postPerformanceReviewFormsIdReopenResponse>(getPostPerformanceReviewFormsIdReopenUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostPerformanceReviewFormsIdReopenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewFormsIdReopen>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewFormsIdReopen>>, TError,{id: string}, TContext> => {

const mutationKey = ['postPerformanceReviewFormsIdReopen'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPerformanceReviewFormsIdReopen>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postPerformanceReviewFormsIdReopen(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPerformanceReviewFormsIdReopenMutationResult = NonNullable<Awaited<ReturnType<typeof postPerformanceReviewFormsIdReopen>>>

    export type PostPerformanceReviewFormsIdReopenMutationError = unknown

    /**
 * @summary Reopen a submitted form (respondent only, while collection is open)
 */
export const usePostPerformanceReviewFormsIdReopen = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPerformanceReviewFormsIdReopen>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPerformanceReviewFormsIdReopen>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getPostPerformanceReviewFormsIdReopenMutationOptions(options), queryClient);
    }
    export type getPerformanceReviewRoundsRoundIdFormsResponse200 = {
  data: void
  status: 200
}

export type getPerformanceReviewRoundsRoundIdFormsResponseSuccess = (getPerformanceReviewRoundsRoundIdFormsResponse200) & {
  headers: Headers;
};
;

export type getPerformanceReviewRoundsRoundIdFormsResponse = (getPerformanceReviewRoundsRoundIdFormsResponseSuccess)

export const getGetPerformanceReviewRoundsRoundIdFormsUrl = (roundId: string,) => {




  return `/performance-review/rounds/${roundId}/forms`
}

/**
 * @summary All forms in a round (admin)
 */
export const getPerformanceReviewRoundsRoundIdForms = async (roundId: string, options?: RequestInit): Promise<getPerformanceReviewRoundsRoundIdFormsResponse> => {

  return customAxios<getPerformanceReviewRoundsRoundIdFormsResponse>(getGetPerformanceReviewRoundsRoundIdFormsUrl(roundId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerformanceReviewRoundsRoundIdFormsQueryKey = (roundId: string,) => {
    return [
    `/performance-review/rounds/${roundId}/forms`
    ] as const;
    }


export const getGetPerformanceReviewRoundsRoundIdFormsQueryOptions = <TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdForms>>, TError = unknown>(roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdForms>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReviewRoundsRoundIdFormsQueryKey(roundId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdForms>>> = ({ signal }) => getPerformanceReviewRoundsRoundIdForms(roundId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(roundId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdForms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReviewRoundsRoundIdFormsQueryResult = NonNullable<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdForms>>>
export type GetPerformanceReviewRoundsRoundIdFormsQueryError = unknown


export function useGetPerformanceReviewRoundsRoundIdForms<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdForms>>, TError = unknown>(
 roundId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdForms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdForms>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdForms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdForms<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdForms>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdForms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdForms>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdForms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdForms<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdForms>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdForms>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary All forms in a round (admin)
 */

export function useGetPerformanceReviewRoundsRoundIdForms<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdForms>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdForms>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPerformanceReviewRoundsRoundIdFormsQueryOptions(roundId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getPerformanceReviewRoundsRoundIdSubjectsUserIdSelfResponse200 = {
  data: void
  status: 200
}

export type getPerformanceReviewRoundsRoundIdSubjectsUserIdSelfResponse403 = {
  data: void
  status: 403
}

export type getPerformanceReviewRoundsRoundIdSubjectsUserIdSelfResponse404 = {
  data: void
  status: 404
}

export type getPerformanceReviewRoundsRoundIdSubjectsUserIdSelfResponseSuccess = (getPerformanceReviewRoundsRoundIdSubjectsUserIdSelfResponse200) & {
  headers: Headers;
};
export type getPerformanceReviewRoundsRoundIdSubjectsUserIdSelfResponseError = (getPerformanceReviewRoundsRoundIdSubjectsUserIdSelfResponse403 | getPerformanceReviewRoundsRoundIdSubjectsUserIdSelfResponse404) & {
  headers: Headers;
};

export type getPerformanceReviewRoundsRoundIdSubjectsUserIdSelfResponse = (getPerformanceReviewRoundsRoundIdSubjectsUserIdSelfResponseSuccess | getPerformanceReviewRoundsRoundIdSubjectsUserIdSelfResponseError)

export const getGetPerformanceReviewRoundsRoundIdSubjectsUserIdSelfUrl = (roundId: string,
    userId: string,) => {




  return `/performance-review/rounds/${roundId}/subjects/${userId}/self`
}

/**
 * @summary Get the submitted self-form of a subject (visible to admins and to peer/manager reviewers assigned to this subject)
 */
export const getPerformanceReviewRoundsRoundIdSubjectsUserIdSelf = async (roundId: string,
    userId: string, options?: RequestInit): Promise<getPerformanceReviewRoundsRoundIdSubjectsUserIdSelfResponse> => {

  return customAxios<getPerformanceReviewRoundsRoundIdSubjectsUserIdSelfResponse>(getGetPerformanceReviewRoundsRoundIdSubjectsUserIdSelfUrl(roundId,userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerformanceReviewRoundsRoundIdSubjectsUserIdSelfQueryKey = (roundId: string,
    userId: string,) => {
    return [
    `/performance-review/rounds/${roundId}/subjects/${userId}/self`
    ] as const;
    }


export const getGetPerformanceReviewRoundsRoundIdSubjectsUserIdSelfQueryOptions = <TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdSelf>>, TError = void>(roundId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdSelf>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReviewRoundsRoundIdSubjectsUserIdSelfQueryKey(roundId,userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdSelf>>> = ({ signal }) => getPerformanceReviewRoundsRoundIdSubjectsUserIdSelf(roundId,userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(roundId && userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdSelf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReviewRoundsRoundIdSubjectsUserIdSelfQueryResult = NonNullable<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdSelf>>>
export type GetPerformanceReviewRoundsRoundIdSubjectsUserIdSelfQueryError = void


export function useGetPerformanceReviewRoundsRoundIdSubjectsUserIdSelf<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdSelf>>, TError = void>(
 roundId: string,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdSelf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdSelf>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdSelf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdSubjectsUserIdSelf<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdSelf>>, TError = void>(
 roundId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdSelf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdSelf>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdSelf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdSubjectsUserIdSelf<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdSelf>>, TError = void>(
 roundId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdSelf>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the submitted self-form of a subject (visible to admins and to peer/manager reviewers assigned to this subject)
 */

export function useGetPerformanceReviewRoundsRoundIdSubjectsUserIdSelf<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdSelf>>, TError = void>(
 roundId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdSelf>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPerformanceReviewRoundsRoundIdSubjectsUserIdSelfQueryOptions(roundId,userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedbackResponse200 = {
  data: void
  status: 200
}

export type getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedbackResponseSuccess = (getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedbackResponse200) & {
  headers: Headers;
};
;

export type getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedbackResponse = (getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedbackResponseSuccess)

export const getGetPerformanceReviewRoundsRoundIdSubjectsUserIdFeedbackUrl = (roundId: string,
    userId: string,) => {




  return `/performance-review/rounds/${roundId}/subjects/${userId}/feedback`
}

/**
 * @summary Aggregated raw peer-feedback for a subject (admin or lead-of-subject)
 */
export const getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback = async (roundId: string,
    userId: string, options?: RequestInit): Promise<getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedbackResponse> => {

  return customAxios<getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedbackResponse>(getGetPerformanceReviewRoundsRoundIdSubjectsUserIdFeedbackUrl(roundId,userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerformanceReviewRoundsRoundIdSubjectsUserIdFeedbackQueryKey = (roundId: string,
    userId: string,) => {
    return [
    `/performance-review/rounds/${roundId}/subjects/${userId}/feedback`
    ] as const;
    }


export const getGetPerformanceReviewRoundsRoundIdSubjectsUserIdFeedbackQueryOptions = <TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback>>, TError = unknown>(roundId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReviewRoundsRoundIdSubjectsUserIdFeedbackQueryKey(roundId,userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback>>> = ({ signal }) => getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback(roundId,userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(roundId && userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReviewRoundsRoundIdSubjectsUserIdFeedbackQueryResult = NonNullable<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback>>>
export type GetPerformanceReviewRoundsRoundIdSubjectsUserIdFeedbackQueryError = unknown


export function useGetPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback>>, TError = unknown>(
 roundId: string,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback>>, TError = unknown>(
 roundId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback>>, TError = unknown>(
 roundId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Aggregated raw peer-feedback for a subject (admin or lead-of-subject)
 */

export function useGetPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback>>, TError = unknown>(
 roundId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdSubjectsUserIdFeedback>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPerformanceReviewRoundsRoundIdSubjectsUserIdFeedbackQueryOptions(roundId,userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type putPerformanceReviewRoundsRoundIdAssignmentsResponse200 = {
  data: void
  status: 200
}

export type putPerformanceReviewRoundsRoundIdAssignmentsResponseSuccess = (putPerformanceReviewRoundsRoundIdAssignmentsResponse200) & {
  headers: Headers;
};
;

export type putPerformanceReviewRoundsRoundIdAssignmentsResponse = (putPerformanceReviewRoundsRoundIdAssignmentsResponseSuccess)

export const getPutPerformanceReviewRoundsRoundIdAssignmentsUrl = (roundId: string,) => {




  return `/performance-review/rounds/${roundId}/assignments`
}

/**
 * @summary Replace peer-assignments for a round (admin)
 */
export const putPerformanceReviewRoundsRoundIdAssignments = async (roundId: string,
    putPerformanceReviewRoundsRoundIdAssignmentsBody: PutPerformanceReviewRoundsRoundIdAssignmentsBody, options?: RequestInit): Promise<putPerformanceReviewRoundsRoundIdAssignmentsResponse> => {

  return customAxios<putPerformanceReviewRoundsRoundIdAssignmentsResponse>(getPutPerformanceReviewRoundsRoundIdAssignmentsUrl(roundId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putPerformanceReviewRoundsRoundIdAssignmentsBody,)
  }
);}




export const getPutPerformanceReviewRoundsRoundIdAssignmentsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPerformanceReviewRoundsRoundIdAssignments>>, TError,{roundId: string;data: PutPerformanceReviewRoundsRoundIdAssignmentsBody}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof putPerformanceReviewRoundsRoundIdAssignments>>, TError,{roundId: string;data: PutPerformanceReviewRoundsRoundIdAssignmentsBody}, TContext> => {

const mutationKey = ['putPerformanceReviewRoundsRoundIdAssignments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPerformanceReviewRoundsRoundIdAssignments>>, {roundId: string;data: PutPerformanceReviewRoundsRoundIdAssignmentsBody}> = (props) => {
          const {roundId,data} = props ?? {};

          return  putPerformanceReviewRoundsRoundIdAssignments(roundId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutPerformanceReviewRoundsRoundIdAssignmentsMutationResult = NonNullable<Awaited<ReturnType<typeof putPerformanceReviewRoundsRoundIdAssignments>>>
    export type PutPerformanceReviewRoundsRoundIdAssignmentsMutationBody = PutPerformanceReviewRoundsRoundIdAssignmentsBody
    export type PutPerformanceReviewRoundsRoundIdAssignmentsMutationError = unknown

    /**
 * @summary Replace peer-assignments for a round (admin)
 */
export const usePutPerformanceReviewRoundsRoundIdAssignments = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPerformanceReviewRoundsRoundIdAssignments>>, TError,{roundId: string;data: PutPerformanceReviewRoundsRoundIdAssignmentsBody}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPerformanceReviewRoundsRoundIdAssignments>>,
        TError,
        {roundId: string;data: PutPerformanceReviewRoundsRoundIdAssignmentsBody},
        TContext
      > => {
      return useMutation(getPutPerformanceReviewRoundsRoundIdAssignmentsMutationOptions(options), queryClient);
    }
    export type getPerformanceReviewRoundsRoundIdAssignmentsResponse200 = {
  data: void
  status: 200
}

export type getPerformanceReviewRoundsRoundIdAssignmentsResponseSuccess = (getPerformanceReviewRoundsRoundIdAssignmentsResponse200) & {
  headers: Headers;
};
;

export type getPerformanceReviewRoundsRoundIdAssignmentsResponse = (getPerformanceReviewRoundsRoundIdAssignmentsResponseSuccess)

export const getGetPerformanceReviewRoundsRoundIdAssignmentsUrl = (roundId: string,) => {




  return `/performance-review/rounds/${roundId}/assignments`
}

/**
 * @summary List peer-assignments for a round (admin)
 */
export const getPerformanceReviewRoundsRoundIdAssignments = async (roundId: string, options?: RequestInit): Promise<getPerformanceReviewRoundsRoundIdAssignmentsResponse> => {

  return customAxios<getPerformanceReviewRoundsRoundIdAssignmentsResponse>(getGetPerformanceReviewRoundsRoundIdAssignmentsUrl(roundId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerformanceReviewRoundsRoundIdAssignmentsQueryKey = (roundId: string,) => {
    return [
    `/performance-review/rounds/${roundId}/assignments`
    ] as const;
    }


export const getGetPerformanceReviewRoundsRoundIdAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignments>>, TError = unknown>(roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignments>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReviewRoundsRoundIdAssignmentsQueryKey(roundId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignments>>> = ({ signal }) => getPerformanceReviewRoundsRoundIdAssignments(roundId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(roundId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReviewRoundsRoundIdAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignments>>>
export type GetPerformanceReviewRoundsRoundIdAssignmentsQueryError = unknown


export function useGetPerformanceReviewRoundsRoundIdAssignments<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignments>>, TError = unknown>(
 roundId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignments>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdAssignments<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignments>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignments>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdAssignments<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignments>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignments>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List peer-assignments for a round (admin)
 */

export function useGetPerformanceReviewRoundsRoundIdAssignments<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignments>>, TError = unknown>(
 roundId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignments>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPerformanceReviewRoundsRoundIdAssignmentsQueryOptions(roundId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserIdResponse200 = {
  data: void
  status: 200
}

export type getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserIdResponseSuccess = (getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserIdResponse200) & {
  headers: Headers;
};
;

export type getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserIdResponse = (getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserIdResponseSuccess)

export const getGetPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserIdUrl = (roundId: string,
    userId: string,) => {




  return `/performance-review/rounds/${roundId}/assignments/suggestions/${userId}`
}

/**
 * @summary Suggested reviewers for a participant (admin)
 */
export const getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId = async (roundId: string,
    userId: string, options?: RequestInit): Promise<getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserIdResponse> => {

  return customAxios<getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserIdResponse>(getGetPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserIdUrl(roundId,userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserIdQueryKey = (roundId: string,
    userId: string,) => {
    return [
    `/performance-review/rounds/${roundId}/assignments/suggestions/${userId}`
    ] as const;
    }


export const getGetPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId>>, TError = unknown>(roundId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserIdQueryKey(roundId,userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId>>> = ({ signal }) => getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId(roundId,userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(roundId && userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId>>>
export type GetPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserIdQueryError = unknown


export function useGetPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId>>, TError = unknown>(
 roundId: string,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId>>, TError = unknown>(
 roundId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId>>, TError = unknown>(
 roundId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Suggested reviewers for a participant (admin)
 */

export function useGetPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId<TData = Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId>>, TError = unknown>(
 roundId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserId>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPerformanceReviewRoundsRoundIdAssignmentsSuggestionsUserIdQueryOptions(roundId,userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getPerformanceReviewQuestionnairesResponse200 = {
  data: void
  status: 200
}

export type getPerformanceReviewQuestionnairesResponseSuccess = (getPerformanceReviewQuestionnairesResponse200) & {
  headers: Headers;
};
;

export type getPerformanceReviewQuestionnairesResponse = (getPerformanceReviewQuestionnairesResponseSuccess)

export const getGetPerformanceReviewQuestionnairesUrl = () => {




  return `/performance-review/questionnaires`
}

/**
 * @summary List active questionnaires
 */
export const getPerformanceReviewQuestionnaires = async ( options?: RequestInit): Promise<getPerformanceReviewQuestionnairesResponse> => {

  return customAxios<getPerformanceReviewQuestionnairesResponse>(getGetPerformanceReviewQuestionnairesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerformanceReviewQuestionnairesQueryKey = () => {
    return [
    `/performance-review/questionnaires`
    ] as const;
    }


export const getGetPerformanceReviewQuestionnairesQueryOptions = <TData = Awaited<ReturnType<typeof getPerformanceReviewQuestionnaires>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReviewQuestionnairesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerformanceReviewQuestionnaires>>> = ({ signal }) => getPerformanceReviewQuestionnaires({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewQuestionnaires>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReviewQuestionnairesQueryResult = NonNullable<Awaited<ReturnType<typeof getPerformanceReviewQuestionnaires>>>
export type GetPerformanceReviewQuestionnairesQueryError = unknown


export function useGetPerformanceReviewQuestionnaires<TData = Awaited<ReturnType<typeof getPerformanceReviewQuestionnaires>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewQuestionnaires>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewQuestionnaires>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewQuestionnaires>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewQuestionnaires<TData = Awaited<ReturnType<typeof getPerformanceReviewQuestionnaires>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewQuestionnaires>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewQuestionnaires>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewQuestionnaires>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewQuestionnaires<TData = Awaited<ReturnType<typeof getPerformanceReviewQuestionnaires>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List active questionnaires
 */

export function useGetPerformanceReviewQuestionnaires<TData = Awaited<ReturnType<typeof getPerformanceReviewQuestionnaires>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPerformanceReviewQuestionnairesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getPerformanceReviewQuestionnairesIdResponse200 = {
  data: void
  status: 200
}

export type getPerformanceReviewQuestionnairesIdResponseSuccess = (getPerformanceReviewQuestionnairesIdResponse200) & {
  headers: Headers;
};
;

export type getPerformanceReviewQuestionnairesIdResponse = (getPerformanceReviewQuestionnairesIdResponseSuccess)

export const getGetPerformanceReviewQuestionnairesIdUrl = (id: string,) => {




  return `/performance-review/questionnaires/${id}`
}

/**
 * @summary Get questionnaire details
 */
export const getPerformanceReviewQuestionnairesId = async (id: string, options?: RequestInit): Promise<getPerformanceReviewQuestionnairesIdResponse> => {

  return customAxios<getPerformanceReviewQuestionnairesIdResponse>(getGetPerformanceReviewQuestionnairesIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPerformanceReviewQuestionnairesIdQueryKey = (id: string,) => {
    return [
    `/performance-review/questionnaires/${id}`
    ] as const;
    }


export const getGetPerformanceReviewQuestionnairesIdQueryOptions = <TData = Awaited<ReturnType<typeof getPerformanceReviewQuestionnairesId>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewQuestionnairesId>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReviewQuestionnairesIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerformanceReviewQuestionnairesId>>> = ({ signal }) => getPerformanceReviewQuestionnairesId(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewQuestionnairesId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReviewQuestionnairesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPerformanceReviewQuestionnairesId>>>
export type GetPerformanceReviewQuestionnairesIdQueryError = unknown


export function useGetPerformanceReviewQuestionnairesId<TData = Awaited<ReturnType<typeof getPerformanceReviewQuestionnairesId>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewQuestionnairesId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewQuestionnairesId>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewQuestionnairesId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewQuestionnairesId<TData = Awaited<ReturnType<typeof getPerformanceReviewQuestionnairesId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewQuestionnairesId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceReviewQuestionnairesId>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceReviewQuestionnairesId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReviewQuestionnairesId<TData = Awaited<ReturnType<typeof getPerformanceReviewQuestionnairesId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewQuestionnairesId>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get questionnaire details
 */

export function useGetPerformanceReviewQuestionnairesId<TData = Awaited<ReturnType<typeof getPerformanceReviewQuestionnairesId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceReviewQuestionnairesId>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPerformanceReviewQuestionnairesIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






